/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabSupplier from './diag-lab-supplier';
import DiagLabSupplierDetail from './diag-lab-supplier-detail';
import DiagLabSupplierUpdate from './diag-lab-supplier-update';
import DiagLabSupplierDeleteDialog from './diag-lab-supplier-delete-dialog';

const DiagLabSupplierRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabSupplier />} />
    <Route path="new" element={<DiagLabSupplierUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabSupplierDetail />} />
      <Route path="edit" element={<DiagLabSupplierUpdate />} />
      <Route path="delete" element={<DiagLabSupplierDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabSupplierRoutes;
